import React from 'react';

const BlockStarIcon = () => {
  const iconColor = '#14607A';
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.28672 0.770943C8.20541 0.601817 8.0376 0.494743 7.85386 0.494743C7.67012 0.494743 7.50232 0.601817 7.421 0.770943L5.44493 4.88093L1.02663 5.53952C0.844792 5.56663 0.693716 5.69735 0.636927 5.87673C0.580139 6.0561 0.627488 6.25301 0.759065 6.38466L3.95627 9.58366L3.20131 14.1012C3.17024 14.2871 3.24468 14.475 3.39334 14.5858C3.54199 14.6967 3.73906 14.7113 3.90169 14.6235L7.85386 12.4906L11.806 14.6235C11.9687 14.7113 12.1657 14.6967 12.3144 14.5858C12.463 14.475 12.5375 14.2871 12.5064 14.1012L11.7515 9.58366L14.9487 6.38466C15.0802 6.25301 15.1276 6.0561 15.0708 5.87673C15.014 5.69735 14.8629 5.56663 14.6811 5.53952L10.2628 4.88093L8.28672 0.770943Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default BlockStarIcon;
